// extracted by mini-css-extract-plugin
export default {"verifyinput_wrap":"InputVerify_verifyinput_wrap__dIzeF","right_send_btn_wrap":"InputVerify_right_send_btn_wrap__BXASl","animate-rotate":"InputVerify_animate-rotate__wR5ox"};